import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaEye, FaFileAlt, FaHeart, FaEnvelope } from 'react-icons/fa';
import './PropertyStats.css';

const PropertyStats = ({ stats }) => {
  const { t } = useTranslation();
  return (
    <div className="property-stats-bar">
      <div className="stat-item">
        <FaEye className="stat-icon" />
        <span className="stat-value">{stats?.viewCount || 0}</span>
        <span className="stat-label">{t('propertyStats.views')}</span>
      </div>
      <div className="stat-item">
        <FaFileAlt className="stat-icon" />
        <span className="stat-value">{stats?.reportCount || 0}</span>
        <span className="stat-label">{t('propertyStats.reports')}</span>
      </div>
      <div className="stat-item">
        <FaHeart className="stat-icon" />
        <span className="stat-value">{stats?.saveCount || 0}</span>
        <span className="stat-label">{t('propertyStats.saves')}</span>
      </div>
      <div className="stat-item">
        <FaEnvelope className="stat-icon" />
        <span className="stat-value">{stats?.inquiryCount || 0}</span>
        <span className="stat-label">{t('propertyStats.inquiries')}</span>
      </div>
    </div>
  );
};

export default PropertyStats;
